import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { ITableCell, ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { Button, DatePicker, Select, Table } from "@ds/ds-snam/react";
import NoDataFound from "components/NoDataFound";
import SimpleTable, { SimpleTableType } from "components/SimpleTable";
import TableRighArrow from "components/TableRightArrow";
import { IBillingReport, IContractBookSlot, IReportElement } from "dataModels/b2b";
import { selectorAPI } from "net/b2b";
import {  getContract, getCustomerDomain, putContractInfo } from "net/contracts";
import { downloadDocument, getPreBillingReport, getValueToP} from "net/prebilling";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Container, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { DsLayout, EntityType, ResponseStatus, RoutePath, SupplyingResultIdStatus } from "shared/constants";
import { IParseDateFormatType, parseDateForDS } from "shared/utils/dateUtils";
import { dsSelectHandler } from "shared/utils/dsComponentUtils";
import { RootState } from "state/appStore";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { v4 as uuid } from "uuid";
import { parseService } from "views/contractView/shared/listUtils";
import { getDSTableShaderElementsForFilterColumn,getDSTableSharedElements, getTableCellsHeaderSimple  } from "shared/utils/dsComponentUtils";
import saveAs from "file-saver";
import { IContract } from "dataModels/contract";
import { Input as TextInput} from "@ds/ds-snam/react";
import { INotificationAction } from "dataModels/stateModels/notification";
const getDateFormatted = (date: Date) => {
    let month=(date.getMonth()+1).toString();
    let day=date.getDate().toString()
    if(month.length===1){ month="0"+month;}
    if(day.length===1){ day="0"+day;}
    return date.getFullYear()+"-"+month+"-"+day+"T00:00:00";
}


const defaultFormData = {
    startDate:'',
    endDate:'',
    businessId:'',
    contractId:''
}


const PreBillingView:React.FC<{}> = ():JSX.Element=>{
    
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation(["preBilling", "app","contract"]);
    const navigate = useNavigate();
    useEffect(() => {
        if (process.env.NODE_ENV !== "development") {
            return;
        }

        const handleResizeObserverError = (event: ErrorEvent) => {
            if (event.message !== "ResizeObserver loop completed with undelivered notifications.") {
                return;
            }

            console.warn("[PreBilling] ResizeObserver:", event.message);
            event.stopImmediatePropagation();
        };

        window.addEventListener("error", handleResizeObserverError, true);

        return () => {
            window.removeEventListener("error", handleResizeObserverError, true);
        };
    }, []);

    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const [formData,setFormData]=useState<IBillingReport>(defaultFormData);
    const [reportList, setReportList] = useState<IReportElement[]>([]);
    const [reportListFiltered,setReportListFiltered] = useState<IReportElement[]>([]);
    const [customerList, setCustomerList] = useState<ISelectLabel[]>([]);
    const [contractList, setContractList] = useState<IContractBookSlot[] | undefined>();
    const [contractData, setContractData] = useState<IContract|null>(null);

    const onTextInputChange = (inputEvent: Event) => {
        if(contractData && contractData!==null){
            const fieldName = (inputEvent as CustomEvent).detail.input.name;
            let currentContractData: IContract = contractData;
            (currentContractData[fieldName as keyof IContract] as string) = (inputEvent as CustomEvent).detail.input.value;
            setContractData(currentContractData);
        }
    }

    const loadContractData = () => {
        if(formData.contractId!==null && formData.contractId!=="" && formData.contractId!=="-1"){
            dispatch(requestPending());
            getContract(formData.contractId)
            .then((response) => {
                const contractResponse = response.data;
                setContractData(contractResponse);
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            });
        }

    }

    const saveContractData = () => {
        if(contractData && contractData !==null){
            const request =putContractInfo;
            dispatch(requestPending());
            request(contractData)
                .then((response) => {
                    loadCustomers();
                    setContractList(undefined)
                    let currentFormData = defaultFormData;
                    currentFormData.startDate=getDateFormatted(new Date());
                    currentFormData.endDate=getDateFormatted(new Date());
                    setFormData(currentFormData)
                    setContractData(null);
                    setValueTop(null);
                    setReportList([]);
                    setReportListFiltered([]);
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                })
        }
    }

    const loadContracts = useCallback((businessId:string) => {
        //console.log('calling load contracts with: ',businessId)
        dispatch(requestPending());
        selectorAPI(EntityType.CONTRACT,businessId)
            .then((response: any) => {
                setContractList(response);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            })
    
    
    }, [dispatch]);

    const loadCustomers = useCallback(() => {
        dispatch(requestPending());
        getCustomerDomain('b2b',"false")
            .then((response: ISelectLabel[]) => {
                setCustomerList(response);
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            })
    }, [dispatch]);

    useEffect(()=>{
        if(formData.businessId!==''){
            loadContracts(formData.businessId)
        }
    },[formData.businessId])

    useEffect(() => {
        loadCustomers();
        let currentFormData = {...formData};
        currentFormData.startDate=getDateFormatted(new Date());
        currentFormData.endDate=getDateFormatted(new Date());
        setFormData(currentFormData)
    }, []);

    const [filters, setFilters] = useState<{ [key: string]: string }>({
            col1: "",
            col6: "",
            col8: "",
            col9: "",
    });

    useEffect(()=>{
        if(formData.contractId!==''&&formData.contractId!=='-1'){
            loadContractData();
            getValueTakeOrPay();
        }
        if(formData.contractId==='' || formData.contractId==='-1'){
            setContractData(null);
            setValueTop(null);
        }
        if(formData!==defaultFormData){
            dispatch(requestPending());
            getPreBillingReport(formData.startDate,formData.endDate,formData.businessId,formData.contractId)
                .then((response: any) => {
                    setReportList(response);
                    setReportListFiltered(response);
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                })
        }
    },[formData,formData.contractId,formData.businessId])
    
    const tableCols = (() => {
        return [t('preBilling.preBillingView.cols.0'),t('preBilling.preBillingView.cols.1'),t('preBilling.preBillingView.cols.2'),t('preBilling.preBillingView.cols.3'),t('preBilling.preBillingView.cols.4'),t('preBilling.preBillingView.cols.5'),t('preBilling.preBillingView.cols.6'),t('preBilling.preBillingView.cols.7'),t('preBilling.preBillingView.cols.8'),t('preBilling.preBillingView.cols.9'),t('preBilling.preBillingView.cols.10'),t('preBilling.preBillingView.cols.11'),t('preBilling.preBillingView.cols.12'),t('preBilling.preBillingView.cols.13'),""]
    })();

    const getClosureText = (supplyingResultId:number) => {
        switch(supplyingResultId){
            case SupplyingResultIdStatus.CANCELED:
                return t('preBilling.preBillingData.labels.13')
            case SupplyingResultIdStatus.FTD:
                return "Failure To Deliver"
            case SupplyingResultIdStatus.FTT:
                return "Failure To Take"
            case SupplyingResultIdStatus.NEGATIVE:
                return "Negative"
            case SupplyingResultIdStatus.POSITIVE:
                return t('preBilling.preBillingData.labels.14')
            default:
                return ""
        }
    }
    

    const tableRows = reportListFiltered.map((report: IReportElement) => {
        return <tr key={uuid()}>
            <td>{report.reservationCode}</td>
            <td>{report.businessName/*report.clientId*/}</td>
            <td>{report.contractCode/*report.contractId*/}</td>
            <td>{parseDateForDS(report.date,IParseDateFormatType.DATE_FORMAT2)}</td>
            <td>{report.time}</td>
            <td>{parseService(report.service)}{/*report.service*/}</td>
            <td>{report.cost}</td>
            <td>{report.shipperName}</td>
            <td>{getClosureText(report.supplyingResultId)}{/*report.supplyingResultId*/}</td>
            <td>{report.energy}</td>
            <td>{report.mass}</td>
            <td><TableRighArrow onClick={() => {
                navigate(RoutePath.PRE_BILLING_INFO +  `/${report.codeIup}`,{state:{report:report}});
            }} /></td>{/** */}
        </tr>

    });

    const getTotalCost = () => {
        let totalCost = 0;
        for(let i in reportList){
            totalCost=totalCost+Number(reportList[i].cost);
        }
        //return totalCost
        return Math.floor(totalCost * 100) / 100; // Troncamento a 2 cifre decimali
    }

    const [valueTop,setValueTop] = useState<number|null>(null);

    const getValueTakeOrPay = () => {
        getValueToP(formData.contractId)
            .then((response: any) => {
                if(response.code && response.code==='422'){
                    setValueTop(null);
                }else{
                    setValueTop(response);
                }
                
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                dispatch(requestPristine());
            });
    }

    const formatOptionalNumber = (value?: number | null): string => {
        return value !== undefined && value !== null ? value.toString() : "-";
    };

    const getTableRowsReport = (): ITableRow[] => {
            let myRetArr: ITableRow[] = [];
            let test : ITableCell
            for (let i in reportListFiltered) {
                let tempObj: ITableRow = {
                    tableCells: [
                        { 
                            type: "text", 
                            text: reportListFiltered[i].reservationCode,
                        },
                        { 
                            type: "text", 
                            text: reportListFiltered[i].businessName,
                        },
                        { 
                            type: "text", 
                            text: reportListFiltered[i].contractCode,
                        },
                        { 
                            type: "text", 
                            text: parseDateForDS(reportListFiltered[i].date,IParseDateFormatType.DATE_FORMAT2),
                        },
                        { 
                            type: "text", 
                            text: reportListFiltered[i].time,
                        },
                        { 
                            type: "text", 
                            text: parseService(reportListFiltered[i].service),
                        },
                        { 
                            type: "text", 
                            text: reportListFiltered[i].cost.toString(),
                        },
                        { 
                            type: "text", 
                            text: reportListFiltered[i].shipperName,
                        },
                        { 
                            type: "text", 
                            text: getClosureText(reportListFiltered[i].supplyingResultId),
                        },
                        { 
                            type: "text", 
                            text: reportListFiltered[i].energy.toString(),
                        },
                        { 
                            type: "text", 
                            text: reportListFiltered[i].mass.toString(),
                        },
                        {
                            type: "text",
                            text: formatOptionalNumber(reportListFiltered[i].percentageBioLng),
                        },
                        {
                            type: "text",
                            text: formatOptionalNumber(reportListFiltered[i].fossil),
                        },
                        {
                            type: "text",
                            text: formatOptionalNumber(reportListFiltered[i].bioLngQuantity),
                        },
                    ],
                    rightIcon: "icon-chevron-right",
                };
                myRetArr.push(tempObj);
            }
            return myRetArr;
        };
    const myTableConfigReport: ITableConfig = {
                ...getDSTableSharedElements(560),
                tableHeader: {
                    
                    tableCellsHeader: [
                        {
                            ...getDSTableShaderElementsForFilterColumn(t('preBilling.preBillingView.cols.0') as string,"col1","8%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                            searchBoxValue:filters["col1"], //<---
                        },
                        getTableCellsHeaderSimple(t('preBilling.preBillingView.cols.1') as string,"col2","8%","left"),
                        getTableCellsHeaderSimple(t('preBilling.preBillingView.cols.2') as string,"col3","7%","left"),
                        getTableCellsHeaderSimple(t('preBilling.preBillingView.cols.3') as string,"col4","7%","left"),
                        getTableCellsHeaderSimple(t('preBilling.preBillingView.cols.4') as string,"col5","7%","left"),
                        {
                            ...getDSTableShaderElementsForFilterColumn(t('preBilling.preBillingView.cols.5') as string,"col6","7%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                            searchBoxValue:filters["col6"], //<---
                        },
                        getTableCellsHeaderSimple(t('preBilling.preBillingView.cols.6') as string,"col7","7%","left"),
                        {
                            ...getDSTableShaderElementsForFilterColumn(t('preBilling.preBillingView.cols.7') as string,"col8","7%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                            searchBoxValue:filters["col8"], //<---
                        },
                        {
                            ...getDSTableShaderElementsForFilterColumn(t('preBilling.preBillingView.cols.8') as string,"col9","7%",t('general.buttons.cancel', { ns: 'app' }),t('general.buttons.confirm', { ns: 'app' }),t('general.buttons.search', { ns: 'app' })),
                            searchBoxValue:filters["col9"], //<---
                        },
                        getTableCellsHeaderSimple(t('preBilling.preBillingView.cols.9') as string,"col10","7%","left"),
                        getTableCellsHeaderSimple(t('preBilling.preBillingView.cols.10') as string,"col11","7%","left"),
                        getTableCellsHeaderSimple(t('preBilling.preBillingView.cols.11') as string,"col12","7%","left"),
                        getTableCellsHeaderSimple(t('preBilling.preBillingView.cols.12') as string,"col13","7%","left"),
                        getTableCellsHeaderSimple(t('preBilling.preBillingView.cols.13') as string,"col14","7%","left"),
                    ],
                    hasSearchBox: true,
                },
                tableRows: getTableRowsReport()
            };

    const getReportListSearchColumns = (index: number) => {
        return (
            index === 0 ||
            index === 5 ||
            index === 7 ||
            index === 8 
        );
    };

    // Gestione dei cambiamenti dei filtri
    const handleFilterChange = (columnKey: string, value: string) => {
        //console.log(columnKey + " - " + value)
        setFilters((prevFilters) => ({
            ...prevFilters,
            [columnKey]: value,
        }));
    };

    /**FILTER */
    useEffect(() => {
            let myFilteredList: IReportElement[] = [];
            for (let i in reportList) {
            const serviceStr = parseService(reportList[i].service); // Ottieni la stringa del servizio
            const closureStatusToTake = [];
            //FTT = 1, //Failure to take
            //FTD = 2, //Failure to delivery
            //CANCELED = 3 //Annullato
            if ("annullato".includes(filters.col9.toLowerCase()) || "cancellato".includes(filters.col9.toLowerCase())) {
                closureStatusToTake.push(SupplyingResultIdStatus.CANCELED);
            }
            if ("failure to deliver".includes(filters.col9.toLowerCase())) {
                closureStatusToTake.push(SupplyingResultIdStatus.FTD);
            }
            if ("failure to take".includes(filters.col9.toLowerCase())) {
                closureStatusToTake.push(SupplyingResultIdStatus.FTT);
            }
            if ("positive".includes(filters.col9.toLowerCase()) || "positivo".includes(filters.col9.toLowerCase())) {
                closureStatusToTake.push(SupplyingResultIdStatus.POSITIVE);
            }
            //console.log(closureStatusToTake)
            
            if (
                reportList[i].reservationCode.toLocaleLowerCase().includes(filters.col1.toLocaleLowerCase()) &&
                serviceStr.toLocaleLowerCase().includes(filters.col6.toLocaleLowerCase()) &&
                reportList[i].shipperName.toLocaleLowerCase().includes(filters.col8.toLocaleLowerCase()) &&
                (closureStatusToTake.includes(reportList[i].supplyingResultId) || (closureStatusToTake.length === 0 && filters.col9 === ""))
            ) {
                myFilteredList.push(reportList[i]);
            }
            }
            setReportListFiltered(myFilteredList);
        }, [
            filters
    ]);

    const exportDocument = (type: string) => {
        if(formData!==defaultFormData){
            dispatch(requestPending());
            downloadDocument(type,formData.startDate,formData.endDate,formData.businessId,formData.contractId)
                .then((response: any) => {
                    if(type==='report'){
                        let file = new File(
                            [response.data],
                            "report" + ".xlsx"
                        );
                        saveAs(file);
                    }
                    if(type==='preInvoice'){
                        let file = new File(
                            [response.data],
                            "preInvoice" + ".pdf"
                        );
                        saveAs(file);
                    }
                    
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    dispatch(requestPristine());
                })
        }
    }

    return (
        <>
                <div>
                    <Row>
                        <Col>
                            <p className="pageTitle">
                                {t('preBilling.preBillingView.titles.0')}{/*Report*/}
                            </p>
                        </Col>
                    </Row>
                    {/*<Row>
                        <Col>
                            <div className="pageSubTitle">
                                <div>
                                    {t('preBilling.preBillingView.titles.1')}
                                </div>
                            </div>
                        </Col>
                    </Row>*/}
                    <Row style={{marginTop:'30px'}}>
                        <Col xs={12} md={3}>
                            <Select
                                id="customerSelector"
                                selectId="customerSelector"
                                menuPlaceholder=""
                                hasIcon={false}
                                menuOptions={customerList === undefined ? [] : customerList}
                                menuLabel={t('preBilling.preBillingView.labels.0') /*"Nome cliente"*/}
                                menuId="select-id"
                                isDisabled={false}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    
                                    const customer: ISelectLabel = (event as CustomEvent).detail.option;
                                    const customerSelected : string = (event as CustomEvent).detail.option.value;
                                    dsSelectHandler(customerList, customer);
                                    let currentFormData = {...formData};
                                    currentFormData.businessId=customerSelected;
                                    if(customerSelected!==formData.businessId){
                                        currentFormData.contractId='-1';
                                    }
                                    setFormData(currentFormData);
                                }}

                            ></Select>
                        </Col>
                        <Col xs={12} md={3}>
                            <Select
                                id="contactSelection"
                                menuPlaceholder=""
                                hasIcon={false}
                                menuOptions={contractList === undefined ? [] : contractList}
                                menuLabel={t('preBilling.preBillingView.labels.1') /*"Contratto*"*/}
                                menuId="select-contract"
                                isDisabled={contractList === undefined}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    const contract = (event as CustomEvent).detail.option;
                                    const contractSelected = (event as CustomEvent).detail.option.value
                                    dsSelectHandler(contractList as ISelectLabel[], contract);
                                    let currentFormData = {...formData};
                                    currentFormData.contractId=contractSelected;
                                    setFormData(currentFormData);
                                }}
                            ></Select>
                        </Col>
                        <Col xs={12} md={3}>
                            <DatePicker
                                id="endDate"
                                datePickerTitle={t('preBilling.preBillingView.labels.5')}//"Dal*/al*" //
                                isRangePicker={true}
                                datePickerVariant="full-date"
                                datePickerPlaceholder=""
                                startingYear={1990}
                                endingYear={2099}
                                defaultDate={new Date()}
                                selectedValue={formData.startDate===''?new Date():new Date(formData.startDate)}
                                secondSelectedValue={formData.startDate===''?new Date():new Date(formData.endDate)}
                                isDisabled={false}
                                datePickerStatus="default"
                                confirmButtonLabel={t('preBilling.preBillingView.labels.6')}//"Conferma"
                                hasCloseButton={false}
                                zIndex={999}
                                isReadonly={false}
                                onDateSelection={(event: Event) => {
                                    const date: string = (event as CustomEvent).detail.dateSelection;
                                    //console.log(date)
                                    let startDate=date.substring(6,10)+'-'+date.substring(3,5)+'-'+date.substring(0,2)+'T00:00:00';
                                    let endDate=date.substring(19,23)+'-'+date.substring(16,18)+'-'+date.substring(13,15)+'T00:00:00';
                                    let currentFormData = {...formData};
                                    currentFormData.startDate=startDate;
                                    currentFormData.endDate=endDate;
                                    setFormData(currentFormData);
                                }}
                            ></DatePicker> 
                        </Col>
                        <Col xs={12} md={3}>
                            {(formData.contractId!=='-1' && formData.contractId!=='') && valueTop!==null &&
                                <div style={{width:'fit-content',float:'right',marginTop:'30px',marginLeft:'12px'}}>
                                    <div style={{fontSize:'65%',width:'fit-content',float:'right',marginBottom:'2px',color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{'TOP'}</div>
                                    <div style={{fontWeight:'bold',color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{valueTop}</div>
                                </div>
                            }
                            <div style={{width:'fit-content',float:'right',marginTop:'30px'}}>
                                <div style={{fontSize:'65%',width:'fit-content',float:'right',marginBottom:'2px',color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{t('preBilling.preBillingView.labels.4')}</div>
                                <div style={{fontWeight:'bold',color:layoutMode===DsLayout.DARK_MODE?"white":"black"}}>{getTotalCost()} €</div>
                            </div> 
                            
                        </Col>
                    </Row>
                    {(contractData && contractData!==null) && 
                        <Row style={{marginTop:'24px'}}>
                            <Col xs={12} md={3}>
                                <div className="textInputWrapper">
                                    <TextInput
                                        inputLabel={t('contract.contractForm.sections.dataInput.fields.4', {ns:['contract']}) + " " + contractData.code}//"Percentuale ToP"
                                        inputValue={contractData.topPercentage.toString()}
                                        inputName="topPercentage"
                                        inputId="topPercentage"
                                        inputDescription="%"
                                        inputStatus="default"
                                        inputPlaceholder=""
                                        isDisabled={false}
                                        input-event-type="single_character"
                                        isNumberVariant={true}
                                        maxValue={100}
                                        minValue={0}
                                        incrementButtonAriaLabel="increment aria text"
                                        decrementButtonAriaLabel="decrement aria text"
                                        isReadonly={false}
                                        onInputChange={onTextInputChange}
                                    />
                                    {/*<p className="textInputWrapperDesc">%</p>*/}
                                </div>
                            </Col>
                            <Col xs={12} md={3}>
                                <div className="textInputWrapper" style={{marginTop:'21px'}}>
                                    <Button
                                        buttonType="button"
                                        buttonUIVariant="primary"
                                        buttonSize="medium"
                                        buttonLabel={t('general.buttons.confirm', { ns: 'app' })}//"Conferma"
                                        buttonIcon=""
                                        isDisabled={false}
                                        onClickEvent={(event: Event) => {
                                            saveContractData();
                                        }}
                                    />
                                </div>
                            </Col>
                        </Row>
                    }

                    
                    <>
                        
                        { reportList.length!==0 ?
                            <Table 
                                tableConfig={myTableConfigReport} 
                                style={{}}
                                onInputSearchBarChange={(event:Event)=>{
                                    //console.log((event as CustomEvent).detail.searchedText + " - " + (event as CustomEvent).detail.cells)
                                }}
                                //FILTERS
                                  onClickRightAction={(event:Event)=>{
                                      //console.log(event)
                                        navigate(RoutePath.PRE_BILLING_INFO +  `/${reportListFiltered[(event as CustomEvent).detail.row].codeIup}`,{state:{report:reportListFiltered[(event as CustomEvent).detail.row]}});
                                    }}
                                    onSubmitSearchedText={(event:Event)=>{
                                    const focusColtemp = (event as CustomEvent).detail.cells;
                                    let focusCol = '';
                                    switch (focusColtemp) {
                                        case 0:
                                            focusCol = "col1";
                                            break;
                                        case 1:
                                            focusCol = "col2";
                                            break;
                                        case 2:
                                            focusCol = "col3";
                                            break;
                                        case 3:
                                            focusCol = "col4";
                                            break;
                                        case 4:
                                            focusCol = "col5";
                                            break;
                                        case 5:
                                            focusCol = "col6";
                                            break;
                                        default:
                                            break;
                                    }
                                    const focusValue = (event as CustomEvent).detail.searchedText;
                                    handleFilterChange(focusCol, focusValue)
                                }}
                                onResetSearch={(event:Event)=>{
                                    //console.log('cliccata cella: ' + (event as CustomEvent).detail.cells);
                                    switch ((event as CustomEvent).detail.cells) {
                                        case 0:
                                            handleFilterChange("col1", "");
                                            break;
                                        case 1:
                                            handleFilterChange("col2", "");
                                            break;
                                        case 2:
                                            handleFilterChange("col3", "");
                                            break;
                                        case 3:
                                            handleFilterChange("col4", "");
                                            break;
                                        case 4:
                                            handleFilterChange("col5", "");
                                            break;
                                        case 5:
                                            handleFilterChange("col6", "");
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                                  onTableInputChange={(event:Event)=>{
                                    //console.log(event)
                                    const focusCol = (event as CustomEvent).detail.col;
                                    const focusValue = (event as CustomEvent).detail.value;
                                    //console.log(focusCol + " - " + focusValue)
                                    //handleFilterChange(focusCol, focusValue)
                                  }}
                                  onColumnSorting={(event:Event)=>{
                                      //console.log((event as CustomEvent).detail.columnID) 
                                  }}                                
                            />
                        :
                        <div style={{marginTop:'25px'}}><NoDataFound
                            title={t('preBilling.preBillingView.titles.4')}
                            subTitle={t('preBilling.preBillingView.titles.5')}
                        /></div>
                        }


                    </>
                    <Button 
                        style={{  float:'right',marginLeft:'15px',marginTop:'20px'}}
                        buttonUIVariant="primary"
                        buttonSize="medium"
                        buttonLabel={t('preBilling.preBillingView.labels.2')} //"Esporta Report"
                        isDisabled={reportList.length===0}
                        onClickEvent={() => {
                             exportDocument("report");       
                        }}
                    ></Button>  
                    <Button 
                        style={{float:'right',marginTop:'20px'}}
                        buttonUIVariant="secondary"
                        buttonSize="medium"
                        buttonLabel={t('preBilling.preBillingView.labels.3')} //"Scarica Pre-fattura"
                        isDisabled={reportList.length===0}
                        onClickEvent={() => {
                            exportDocument("preInvoice");
                        }}
                    ></Button>
                </div> 
        </>
    );
}
export default PreBillingView;